import type { DimensionDescriptor } from "../../../../../../../../api/types/svTypes.ts";
import type { AxesContext, AxisOutcome } from "../utils/statementColumns.ts";
import { resolveFieldForAxes } from "../utils/statementColumns.ts";

export const resolveDimensionGroupForAxes = (
  dimensions: DimensionDescriptor[],
  context: AxesContext
): AxisOutcome[] => {
  const outcomes = dimensions.reduce<AxisOutcome[]>((resolved, dimension) => {
    const axes = [...context.axes, ...resolved.flatMap((outcome) => (outcome.kind === "add" ? [outcome.axis] : []))];
    return [...resolved, resolveFieldForAxes({ kind: "dimension", dimension }, { ...context, axes })];
  }, []);
  const added = outcomes.filter((outcome) => outcome.kind === "add");
  if (added.length > 0) {
    return added;
  }
  const refusal = outcomes.find((outcome) => outcome.kind === "refuse");
  return refusal ? [refusal] : [];
};
